import poweredByModica from "../assets/poweredbymodica_logo.svg";
import "./brand.css";

/** Shared Modica "powered by" mark (brand-level, not theme-specific). */
export function ModicaFooter() {
  return <img className="modica-footer" src={poweredByModica} alt="Powered by Modica Group" height={20} />;
}
